import React from 'react'
import Navbar from '../../Components/navbar/navbar.jsx'
import Landing from '../../Pages/Header/header'
import Work from '../../Pages/How_It_Work/work'
import FromAi from '../Form_Ai/From_Ai'
import Second from '../Form_Ai/Second'
import Third from '../Form_Ai/Third'
import Slider from '../Slider/Slider'
import MainFooter from '../../Components/Footer/MainFooter.jsx'

const home = () => {
  return (
    <div className='main'>
      <Navbar />
      <Landing />
      <Work />
      <FromAi />
      <Second />
      <Third />
      <Slider />
      <MainFooter />
    </div>
  )
}

export default home